(function($) {
	var pagify = {
		items: {},
		container: null,
		totalPages: 1,
		perPage: 3,
		currentPage: 0,
		createNavigation: function() 
		{
			this.totalPages = Math.ceil(this.items.length / this.perPage);

			var currentStart = (this.currentPage * this.perPage) + 1;
			var currentEnd = (this.currentPage * this.perPage) + 5;
			if (currentEnd > this.items.length)
			{
				currentEnd = this.items.length;
			}

			$('.sol_pagination').removeClass("hide");
			$('.sol_pagination2').removeClass("hide");

			wherenow = "<div class='pagcol1'>Results <strong id='currentStart'>" + currentStart + "</strong>-<strong id='currentEnd'>" + currentEnd + "</strong> of <strong>" + this.items.length + "</strong> <br /><small>Ordered by distance from your location.</small>";

			$('.sol_pagination', this.container.parent()).remove();
			$('.sol_pagination2', this.container.parent()).remove();
			var sol_pagination = $('<div class="sol_pagination"></div>').append(wherenow).append('<div class="pagcol2"><a class="nav prev disabled" data-next="false" aria-label="Previous results"><</a>');
			//var sol_pagination2 = $('<div class="sol_pagination2"></div>').append('<a class="nav prev disabled" data-next="false" aria-label="Previous results"><</a>').append('<a class="nav next" data-next="true" aria-label="Next results">></a>');
			
			var sol_pagination2 = '<p class="sol_pagination2"><a class="nav prev disabled" data-next="false" aria-label="Previous results"><</a> &nbsp; <a class="nav next" data-next="true" aria-label="Next results">></a></p>';

			/*for (var i = 0; i < this.totalPages; i++) {
				var pageElClass = "page";
				if (!i)
					pageElClass = "page current";
				var pageEl = '<a class="' + pageElClass + '" data-page="' + (
				i + 1) + '">' + (
				i + 1) + "</a>";
				sol_pagination.append(pageEl);
			}*/

			sol_pagination.append('<div class="pagcol3"><a class="nav next" data-next="true" aria-label="Next results">></a>');
			//sol_pagination2;

			this.container.before(sol_pagination);
			this.container.after(sol_pagination2);

			var that = this;
			$("body").off("click", ".nav");
			this.navigator = $("body").on("click", ".nav", function() {
				var el = $(this);
				that.navigate(el.data("next"));
			});

			$("body").off("click", ".page");
			this.pageNavigator = $("body").on("click", ".page", function() {
				var el = $(this);
				that.goToPage(el.data("page"));
			});
		},
		navigate: function(next) {

			// default perPage to 5
			if (isNaN(next) || next === undefined) {
				next = true;
			}
			$(".sol_pagination .nav").removeClass("disabled");
			$(".sol_pagination2 .nav").removeClass("disabled");
			if (next) {
				this.currentPage++;
				if (this.currentPage > (this.totalPages - 1))
					this.currentPage = (this.totalPages - 1);
				if (this.currentPage == (this.totalPages - 1))
				{
					$(".sol_pagination .nav.next").addClass("disabled");
					$(".sol_pagination2 .nav.next").addClass("disabled");
				}
			}
			else 
			{
				this.currentPage--;
				if (this.currentPage < 0)
					this.currentPage = 0;
				if (this.currentPage == 0)
				{
					$(".sol_pagination .nav.prev").addClass("disabled");
					$(".sol_pagination2 .nav.prev").addClass("disabled");
				}
			}

			this.showItems();
		},
		updateNavigation: function() 
		{

			var currentStart = (this.currentPage * this.perPage) + 1;
			var currentEnd = (this.currentPage * this.perPage) + 5;
			if (currentEnd > this.items.length)
			{
				currentEnd = this.items.length;
			}

			$('.sol_pagination #currentStart').html(currentStart);
			$('.sol_pagination #currentEnd').html(currentEnd);

			if (this.totalPages == 1)
			{
				$(".sol_pagination .nav.next").addClass("disabled");
				$(".sol_pagination2 .nav.next").addClass("disabled");
			}

			/*var pages = $(".sol_pagination .page");
			pages.removeClass("current");
			$('.sol_pagination .page[data-page="' + (
			this.currentPage + 1) + '"]').addClass("current");*/
		},
		goToPage: function(page) {

			this.currentPage = page - 1;

			$(".sol_pagination .nav").removeClass("disabled");
			$(".sol_pagination2 .nav").removeClass("disabled");

			if (this.currentPage == (this.totalPages - 1))
			{
				$(".sol_pagination .nav.next").addClass("disabled");
				$(".sol_pagination2 .nav.next").addClass("disabled");
			}

			if (this.currentPage == 0)
			{
				$(".sol_pagination .nav.prev").addClass("disabled");
				$(".sol_pagination2 .nav.prev").addClass("disabled");
			}

			this.showItems();
		},
		showItems: function() 
		{
			this.items.hide();
			var base = this.perPage * this.currentPage;
			this.items.slice(base, base + this.perPage).show();
			localStorage.setItem('storedMapPage', this.currentPage);
			this.updateNavigation();
		},
		init: function(container, items, perPage) 
		{
			var retrievedPageNum = localStorage.getItem('storedMapPage');
	        if (isNaN(retrievedPageNum))
	        {
	            retrievedPageNum = 0;
	        }

			this.container = container;
			this.currentPage = retrievedPageNum;
			this.totalPages = 1;
			this.perPage = perPage;
			this.items = items;
			this.createNavigation();
			this.showItems();
			$('.sol_noresults').addClass("hide");

		}
	};

	// stuff it all into a jQuery method!
	$.fn.pagify = function(perPage, itemSelector) {
		var el = $(this);
		var items = $(itemSelector, el);
		// default perPage to 5
		if (isNaN(perPage) || perPage === undefined) {
			perPage = 3;
		}
		

		// toggle no results
		if (items.length == 0) {
			$('.sol_pagination').addClass("hide");
			$('.sol_pagination2').addClass("hide");
			$('.sol_noresults').removeClass("hide");
			return true;
		}

		pagify.init(el, items, perPage);
	};
})(jQuery);
